module.exports = __webpack_public_path__ + "img/矩形1779.38e2bf85.png";